
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/your-subscription",
      function () {
        return require("private-next-pages/design-system/your-subscription.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/your-subscription"])
      });
    }
  